var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolsideDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 156,
    viewBox: "0 0 123 156",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.909 80.5373C15.909 67.811 26.3189 51.2887 39.0384 43.8151L97.087 11.1107C103.496 7.34424 109.313 6.57267 113.515 8.35289L102.114 2.53429C97.9172 0.778886 92.1162 1.56066 85.7278 5.3138L27.6792 38.0181C14.9598 45.4917 4.5498 62.0164 4.5498 74.7427V148.59L15.909 154.385V80.5373Z",
    fill: "url(#paint0_linear_3_83825)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0386 43.8186L97.0872 11.1142C109.809 3.63805 120.219 7.93119 120.219 20.6552V48.2435C120.219 60.9627 109.809 77.4898 97.0872 84.9635L39.0386 117.665C26.3192 125.139 15.9092 141.666 15.9092 154.388V80.5407C15.9092 67.8144 26.3192 51.2922 39.0386 43.8186Z",
    fill: "url(#paint1_linear_3_83825)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3666 73.2818C45.7813 73.6198 45.2142 74.1981 44.7562 74.921C44.2699 74.322 43.4838 74.255 42.6303 74.7478C42.0139 75.1037 41.4235 75.7187 40.9548 76.49C40.4647 75.9635 39.7029 75.9245 38.8941 76.3914C38.4962 76.6212 38.1038 76.9636 37.749 77.389L37.7461 70.4557C37.7429 68.6736 36.5888 67.8623 35.1738 68.6471C34.508 69.0113 33.8653 69.6947 33.3664 70.5619C32.817 71.5174 32.5028 72.6036 32.5046 73.5418L32.5325 88.7028L31.3661 87.6384C30.3779 86.7364 28.7713 87.1851 27.3674 88.7569C26.8695 89.3141 26.4862 90.0318 26.2881 90.7781C26.0815 91.5563 26.105 92.2853 26.3525 92.7778C26.3597 92.7925 26.3675 92.8062 26.3758 92.8194L33.1293 103.443C33.7995 104.497 35.0359 104.679 36.356 103.917L44.3755 99.2866C45.9611 98.3711 47.3533 96.1426 47.6859 93.9878C48.5299 88.5207 48.9578 83.164 48.9578 78.0663V75.0495C48.9578 73.2499 47.7955 72.4569 46.3666 73.2818ZM33.9832 90.3224L33.9509 72.7032C33.9501 72.2208 34.1066 71.6712 34.3804 71.1952C34.5975 70.8175 34.8693 70.5248 35.1456 70.3722C35.7805 70.02 36.2983 70.4331 36.2999 71.293L36.3029 84.7177C36.3029 85.189 36.6274 85.3851 37.026 85.1548C37.4247 84.9246 37.7491 84.354 37.7491 83.8828V80.3163C37.7491 79.459 38.2627 78.4649 38.8941 78.1004C39.5255 77.7359 40.0391 78.1369 40.0391 78.9942V83.0987C40.0391 83.5697 40.3636 83.7658 40.7623 83.5356C41.1609 83.3054 41.4853 82.7347 41.4853 82.2637C41.4853 81.9886 41.4897 78.7808 41.4955 78.4587C41.571 77.6474 42.0589 76.7867 42.6303 76.4568C43.2618 76.0922 43.7754 76.493 43.7754 77.3503V81.6567C43.7754 82.1277 44.0998 82.3238 44.4985 82.0936C44.8972 81.8634 45.2216 81.2927 45.2216 80.8216V77.2064C45.2216 76.3491 45.7352 75.3553 46.3666 74.9908C46.9979 74.6263 47.5115 75.0271 47.5115 75.8844V78.9011C47.5115 83.8865 47.0931 89.1249 46.2679 94.4705C46.0701 95.7519 45.2742 97.0584 44.3754 97.5774L36.356 102.207C35.5636 102.665 34.8128 102.542 34.3967 101.888L27.6596 91.2912C27.5779 91.1156 27.5723 90.8594 27.6441 90.5888C27.7079 90.3487 27.8237 90.126 27.9702 89.962C28.2152 89.6879 28.472 89.4754 28.7267 89.3283C29.2901 89.0031 29.8429 88.9981 30.2331 89.3545L32.6936 91.5998C32.885 91.7742 33.2087 91.6984 33.4989 91.4105C33.7893 91.123 33.9839 90.6855 33.9832 90.3224Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.3805 83.031C30.4928 83.0457 30.6212 83.0138 30.7518 82.9384C31.0048 82.7923 31.2427 82.4958 31.3725 82.1648C31.4718 81.9119 31.5007 81.6654 31.4539 81.4709C31.407 81.2767 31.2898 81.1576 31.1243 81.1359C28.7569 80.8254 27.3436 78.6929 27.3436 75.4312C27.3436 70.3639 30.8322 64.2273 35.1203 61.7515C39.4084 59.2758 42.8971 61.3841 42.8971 66.4514C42.8971 67.8962 42.6224 69.4364 42.0809 71.0293C41.9027 71.5537 42.0478 71.9843 42.4044 71.9891C42.5774 71.9913 42.7733 71.8953 42.9567 71.7165C43.1399 71.5384 43.2883 71.3006 43.3746 71.0465C44.0174 69.1557 44.3433 67.3286 44.3433 65.6165C44.3433 59.607 40.206 57.1066 35.1204 60.0428C30.0348 62.9789 25.8975 70.2567 25.8975 76.2662C25.8975 80.134 27.5733 82.6628 30.3805 83.031Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.7925 71.9433C38.8449 72.1327 38.9666 72.2449 39.1351 72.2593C39.2431 72.2683 39.3652 72.2356 39.488 72.1648C39.7495 72.0137 39.9916 71.7068 40.1194 71.3633C40.5958 70.0839 40.8477 68.7947 40.8477 67.6356C40.8477 63.9036 38.2784 62.3508 35.1202 64.1742C31.962 65.9976 29.3926 70.5172 29.3926 74.2492C29.3926 75.3228 29.6104 76.2656 30.0227 76.9761C30.111 77.1282 30.2609 77.1919 30.4448 77.1556C30.6287 77.1195 30.8247 76.987 30.9963 76.7836C31.1682 76.5802 31.2954 76.3297 31.3545 76.0783C31.4135 75.8269 31.3975 75.6047 31.3092 75.4526C30.9972 74.9148 30.839 74.229 30.839 73.4141C30.839 70.6244 32.7595 67.2461 35.1203 65.8832C37.4811 64.5202 39.4016 65.6808 39.4016 68.4706C39.4016 69.3375 39.2137 70.301 38.8579 71.2562C38.7635 71.5098 38.7402 71.7539 38.7925 71.9433Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2832 80.1253V63.3444L62.3528 59.2627C65.7998 57.273 67.7113 58.5344 67.7113 61.3268C67.7113 64.1192 65.7742 67.6023 62.3528 69.5777L57.7988 72.2069V78.6729L55.2832 80.1253ZM62.0256 61.6654L57.7988 64.1055V69.9933L62.0256 67.5532C63.8371 66.5075 65.1207 64.5833 65.1207 62.8223C65.1207 61.0612 63.8371 60.6197 62.0256 61.6654Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8896 66.7558C67.8896 63.259 70.2547 59.0257 74.0283 56.8469C77.8274 54.6532 80.1669 56.1705 80.1669 59.6673C80.1669 63.1894 77.8274 67.4083 74.0283 69.6021C70.2547 71.7809 67.8896 70.2778 67.8896 66.7558ZM77.8019 61.0331C77.8019 58.7438 76.4685 57.4503 74.0284 58.8591C71.6131 60.2536 70.2548 63.1013 70.2548 65.3906C70.2548 67.7052 71.6132 68.9843 74.0284 67.5898C76.4685 66.181 77.8019 63.3478 77.8019 61.0331Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0234 59.1699C81.0234 55.6731 83.3878 51.4398 87.1624 49.2608C90.9616 47.0673 93.3011 48.5847 93.3011 52.0814C93.3011 55.6035 90.9616 59.8224 87.1624 62.0155C83.3878 64.195 81.0234 62.692 81.0234 59.1699ZM90.936 53.4466C90.936 51.1573 89.6026 49.8642 87.1624 51.2726C84.7468 52.6671 83.3878 55.5154 83.3878 57.8048C83.3878 60.1193 84.7468 61.3978 87.1624 60.0033C89.6026 58.5945 90.936 55.7613 90.936 53.4466Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9131 57.2407V40.4598L97.1775 39.1523V55.9329L94.9131 57.2407Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_83825",
    x1: -2.03327,
    y1: 151.501,
    x2: 57.9568,
    y2: -4.77819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    stopColor: "#74A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4826,
    stopColor: "#92D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#91D303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#8FCF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#8BC91F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5897,
    stopColor: "#86C037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5972,
    stopColor: "#84BD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6986,
    stopColor: "#84BE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    stopColor: "#86C233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8642,
    stopColor: "#8AC821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9401,
    stopColor: "#8FD109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9639,
    stopColor: "#92D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9747,
    stopColor: "#8CCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#86C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84BD41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_83825",
    x1: 23.784,
    y1: 43.1658,
    x2: 71.1,
    y2: 110.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74A900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolsideDining);
export default __webpack_public_path__ + "static/media/poolside-dining.d6cd7753cc6cdc1c12e11fb7abc94220.svg";
export { ForwardRef as ReactComponent };